/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} New_Project_Summary_Media_TitleInputs */

const en_new_project_summary_media_title = /** @type {(inputs: New_Project_Summary_Media_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Media`)
};

const fr_new_project_summary_media_title = /** @type {(inputs: New_Project_Summary_Media_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Médias`)
};

const de_new_project_summary_media_title = /** @type {(inputs: New_Project_Summary_Media_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Medien`)
};

const it_new_project_summary_media_title = /** @type {(inputs: New_Project_Summary_Media_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Media`)
};

const ru_new_project_summary_media_title = /** @type {(inputs: New_Project_Summary_Media_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`СМИ`)
};

const es_new_project_summary_media_title = /** @type {(inputs: New_Project_Summary_Media_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Medios de comunicación`)
};

const zh_cn2_new_project_summary_media_title = /** @type {(inputs: New_Project_Summary_Media_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`媒体`)
};

const ja_new_project_summary_media_title = /** @type {(inputs: New_Project_Summary_Media_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`メディア`)
};

const hi_new_project_summary_media_title = /** @type {(inputs: New_Project_Summary_Media_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`मिडिया`)
};

const pt_pt2_new_project_summary_media_title = /** @type {(inputs: New_Project_Summary_Media_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mídia`)
};

/**
* | output |
* | --- |
* | "Media" |
*
* @param {New_Project_Summary_Media_TitleInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const new_project_summary_media_title = /** @type {((inputs?: New_Project_Summary_Media_TitleInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<New_Project_Summary_Media_TitleInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_new_project_summary_media_title(inputs)
	if (locale === "de") return de_new_project_summary_media_title(inputs)
	if (locale === "it") return it_new_project_summary_media_title(inputs)
	if (locale === "ru") return ru_new_project_summary_media_title(inputs)
	if (locale === "es") return es_new_project_summary_media_title(inputs)
	if (locale === "zh-CN") return zh_cn2_new_project_summary_media_title(inputs)
	if (locale === "ja") return ja_new_project_summary_media_title(inputs)
	if (locale === "hi") return hi_new_project_summary_media_title(inputs)
	if (locale === "pt-PT") return pt_pt2_new_project_summary_media_title(inputs)
	return en_new_project_summary_media_title(inputs)
});